import { useContext, useEffect, useMemo, useState } from 'react'
import type { Challenge } from 'types/datascience-challenge'
import { DragCTX } from 'components/atoms/drag-context/drag-context'
import { type ScoreState } from 'types/datascience-score'
import { checkDateChallenge } from 'utils/date'
import { fullUrl } from 'utils/image'
import { useOktaUser } from 'hooks/use-okta-user'

const useDSCChallenge = (challenge: Challenge) => {
  const { user } = useOktaUser()
  const [lastScoreState, setLastScoreState] = useState<ScoreState>()
  const { isFileDragged } = useContext(DragCTX)

  const indexChallenge = 'challenges0'
  const challengeStatus = useMemo(
    () => checkDateChallenge(challenge.startDate, challenge.endDate),
    [challenge.startDate, challenge.endDate]
  )

  const myScore = useMemo(
    () =>
      challenge?.datascience_scores?.filter(value => value?.okta_id === user?.sub)?.[0],
    [challenge, user?.sub]
  )

  const urlImage = useMemo(
    () => (challenge?.logo ? fullUrl(challenge.logo?.url) : '/demo.jpg'),
    [challenge?.logo]
  )

  useEffect(() => {
    setLastScoreState(challenge?.last_score_state)
  }, [challenge.last_score_state])

  return {
    challenge,
    challengeStatus,
    indexChallenge,
    isFileDragged,
    lastScoreState,
    myScore,
    setLastScoreState,
    urlImage
  }
}

export { useDSCChallenge }
